import 'react-international-phone/style.css';
import React, { PropsWithRef, forwardRef, useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { FormGroup } from '@vtbhome/juicyfront';
import { InputPhoneProps } from './types';
import { StyledPhoneInput } from './input-phone.styled';
import { IconChevronDown } from '../../icon/icon-chevron-down/icon-chevron-down';
import { PhoneInputRefType } from 'react-international-phone';
import { ErrorMessageInput } from '../error-message-input/error-message-input';

export const InputPhone = forwardRef(
    ({ label, error, hint, ...props }: PropsWithRef<InputPhoneProps>, ref: React.Ref<PhoneInputRefType>) => {
        const [isInit, setIsInit] = useState(false);
        const arrowRef = useRef<HTMLElement | null>(null);

        useEffect(() => {
            const arrowContainer = document.querySelector(
                '.react-international-phone-country-selector-button__dropdown-arrow'
            ) as HTMLElement;
            arrowRef.current = arrowContainer;
            if (arrowContainer) {
                setIsInit(true);
            }
        }, []);

        return (
            <FormGroup
                label={label}
                required={props.required}
                errorMessage={<ErrorMessageInput error={error} hint={hint} />}>
                <StyledPhoneInput ref={ref} defaultCountry='ru' forceDialCode {...props} />
                {isInit && arrowRef.current && createPortal(<IconChevronDown />, arrowRef.current)}
            </FormGroup>
        );
    }
);

InputPhone.displayName = 'InputPhone';
